<template>
    <modal v-if="!useNativeShare" @close="$emit('close')" :open="localOpen">
        <template #header>
            {{ title || 'Share Page' }}
        </template>
        <template #default>
            <slot/>
            
            <container>
                <row>
                    <column :md="12" v-if="canShare || !uiStore.isMobile">
                        <ui-button @click="copyLink" :block="true" class="mb-4 rounded" :outline="true" :color="buttonColor">
                            Copy Link
                        </ui-button>
                    </column>

                    <column :md="12">
                        <ui-button @click="facebook" :block="true" class="mb-4 rounded" :outline="true" :color="buttonColor">
                            Facebook
                        </ui-button>
                    </column>

                    <column v-if="showLinkedIn" :md="12">
                        <ui-button @click="linkedIn" :block="true" class="mb-4 rounded" :outline="true" :color="buttonColor">
                            LinkedIn
                        </ui-button>
                    </column>

                    <template v-if="canShare">

                        <column :md="12">
                            <ui-button @click="share" :block="true" class="mb-4 rounded" :outline="true" :color="buttonColor">
                                Share
                            </ui-button>
                        </column>

                    </template>
                    <template v-else>
                        <column v-if="showSms && uiStore.isMobile" :md="12">
                            <ui-button @click="sms" :block="true" class="mb-4 rounded" :outline="true" :color="buttonColor">
                                SMS
                            </ui-button>
                        </column>

                        <column v-if="showEmail" :md="12">
                            <ui-button @click="email" :block="true" class="mb-4 rounded" :outline="true" :color="buttonColor">
                                Email
                            </ui-button>
                        </column>
                    </template>
                </row>
            </container>

        </template>
        <template #buttons>
            <ui-button color="secondary" @click="localOpen=false" :underline="true">
                Close
            </ui-button>
        </template>
    </modal>
</template>

<script type="text/javascript">

    import CommonComponents from '@/components/Common.vue';
    
    import Utilities from '@/classes/Utilities.js';
    import { UseUIStore } from '@/store/UI.js';

    export default {
        components: {
            ...CommonComponents,
        },

        setup() {
            return {
                uiStore: UseUIStore(),
            };
        },

        data() {
            return {
                useNativeShare: false,
                localOpen: true,
            };
        },

        props: {
            open: {
                type: Boolean,
                default: true,
            },
            
            link: {
                type: String,
            },

            title: {
                type: String,
            },

            headline: {
                type: String,
            },

            snippet: {
                type: String,
            },
            
            buttonColor: {
                type: String,
                default: 'secondary',
            },

            showLinkedIn: {
                type: Boolean,
                default: true,
            },

            showEmail: {
                type: Boolean,
                default: true,
            },

            showSms: {
                type: Boolean,
                default: true,
            },
        },

        emits: ['close', 'share'],

        created() {
            if (
                (this.canShare) &&
                (
                    (this.uiStore.isMobile) ||
                    (this.uiStore.isTablet)
                )
            ) {
                this.useNativeShare = true;
                this.share();

                requestAnimationFrame(function() {
                    this.$emit('close');
                }.bind(this));
            }
            this.localOpen = this.open;
        },

        watch: {
            open(newVal) {
                this.localOpen = newVal;
            }
        },

        computed: {
            shareLink() {
                if (this.link) {
                    return this.link;
                }

                return location.href;
            },

            facebookShareLink() {
                return 'https://www.facebook.com/dialog/share?app_id=671310541800363&display=popup&href='+encodeURIComponent(this.shareLink);
            },

            linkedInShareLink() {
                return 'https://www.linkedin.com/sharing/share-offsite/?url='+encodeURIComponent(this.shareLink);
            },

            shareBody() {
                let body = '';
                if (this.headline) {
                    body += this.headline + "\n"
                }
                if (this.snippet) {
                    body += this.snippet+"\n";
                }

                if (body != '') body += "\n";
                body += this.shareLink;

                

                return body;
            },

            smsShareLink() {
                let prefix = 'tel:';
                if ((this.uiStore.isMobile) || (this.uiStore.isTablet)) {
                    prefix = 'sms:';
                }
                return prefix+'?&body='+encodeURIComponent(this.shareBody);
            },

            emailShareLink() {
                return 'mailto:?subject='+encodeURIComponent(this.headline || (this.title || 'StayMarquis'))+'&body='+encodeURIComponent(this.shareBody);
            },

            canShare() {
                if (
                    (navigator) &&
                    (navigator.canShare)
                ) {
                    return true;
                }
                return false;
            },
        },

        methods: {
            facebook() {
                window.open(this.facebookShareLink, 'share', 'popup');
                this.$emit('share', 'facebook');
            },

            linkedIn() {
                window.open(this.linkedInShareLink, 'share', 'popup');
                this.$emit('share', 'linkedin');
            },

            sms() {
                location.href = this.smsShareLink;
                this.$emit('share', 'sms');
            },

            email() {
                location.href = this.emailShareLink;
                this.$emit('share', 'email');
            },

            share() {
                if (this.canShare) {
                    let obj = {
                        url: this.shareLink,
                    };
                    if (this.headline) {
                        obj.title = this.headline;
                    }
                    if (this.snippet) {
                        obj.text = this.snippet;
                    }
                    navigator.share(obj);

                    this.$emit('share', 'mobile');
                }
            },

            copyLink() {
                if (Utilities.copyText(this.shareLink)) {
                    this.uiStore.toast({
                        info: true,
                        message: 'Copied',
                    });

                    this.$emit('share', 'url');
                }
                else {
                    this.uiStore.toast({
                        danger: true,
                        message: 'Could not copy link',
                    });
                }
            },
        },

    };

</script>
